import React from 'react';
import { Button, Grid, GridColumn, Heading, Modal, ModalProvider, ModalTrigger, Skeleton, SkeletonItem, useAnalytics } from 'telia-front-react';
import { TranslationsContext } from '@telia-common-components/shared';
const AddressNotFoundModal = ({ isLoading }) => {
    const { push } = useAnalytics();
    const { translate } = React.useContext(TranslationsContext);
    if (isLoading) {
        return (React.createElement(Skeleton, { label: translate('skeleton.loading'), className: "text-center" },
            React.createElement(SkeletonItem, { height: "20px", width: "180px" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalProvider, { isClosable: true },
            React.createElement(ModalTrigger, null,
                React.createElement(Button, { element: 'button', text: translate('secureNet.addressNotFoundModal.buttonText'), link: true, onClick: () => {
                        push('Link - Modal - Ei leidnud aadress või ruumi');
                    }, size: 'small' })),
            React.createElement(Modal, { size: '6-col', "aria-labelledby": "secure-net-address-not-found-modal-title" },
                React.createElement(Grid, null,
                    React.createElement(GridColumn, null,
                        React.createElement(Heading, { level: 1, className: "h4 text-bold", id: "secure-net-address-not-found-modal-title" }, translate('secureNet.addressNotFoundModal.contentHeading'))),
                    React.createElement(GridColumn, null, translate('secureNet.addressNotFoundModal.content')))))));
};
export default AddressNotFoundModal;
